module.exports = __webpack_public_path__ + "img/kommune-1638.06978e48.svg";